import { mdiFacebookMessenger } from '@mdi/js';
import signalLogo from '@/assets/imgs/social/signal_logo.svg';
import whatsappLogo from '@/assets/imgs/social/whatsapp_logo.svg';
import telegramLogo from '@/assets/imgs/social/telegram_logo.svg';

export const CONTACT_PHONE = '+213 661 969697';
export const CONTACT_PHONE_URL = 'tel:+213661969697';
export const MESSENGER_URL = 'https://m.me/ilearnquran';
export const MESSENGER_COLOR = '#0866FF';

export const CONTACT_CHANNELS = [
  { label: 'WhatsApp', logo: whatsappLogo, href: 'https://wa.me/213661969697' },
  { label: 'Telegram', logo: telegramLogo, href: 'https://t.me/ilearnquran' },
  { label: 'Signal', logo: signalLogo, href: 'https://signal.me/#p/+213661969697' },
  { label: 'Messenger', icon: mdiFacebookMessenger, color: MESSENGER_COLOR, href: MESSENGER_URL },
];
